import React from 'react'

function Footer() {
    return (
        <div>   
         <footer className="footer text-center py-4">
            <small className="copyright">
                 Copyright ©
                <a href="/" target="_blank">
                    Jahid Hasan Rimel
                </a>
            </small>
        </footer></div>
    )
}

export default Footer